'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = require('./Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Form2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/form/index.js
// module id = 115
// module chunks = 0